import styled from 'styled-components';

export const StyledForm = styled.form`
  margin-top: 20px;

  .form-group {
    margin-bottom: 20px;
    &:last-child {
      margin: 0;
    }
  }

  label {
    display: block;
    font-size: 14px;
    font-family: Poppins, Heltica, Arial, sans-serif;
    margin-bottom: 5px;
  }

  input {
    width: 100%;
    padding: 5px 10px;
    border: 1px solid #C5C6D0;
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 12px;
    color: #4D4C59;
  }
  
  select {
		display: block;
		padding: 3px 5px;
		border-radius: 12px;
		background-color: #FFFFFF;
		border: 1px solid #B7B7B7;
		font-size: 15px;
		color: #4D4C59;
		outline: 0;
  }
  
  button[type='submit'] {
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 15px;
    background-color: #707070;
  }
`;
